"use client";
import { useMediaQuery } from "../hooks/useMediaQuery";
import { Toaster } from "react-hot-toast";

const ToastWindow = ({ children }: { children: React.ReactNode }) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  return (
    <div className="w-full">
      <Toaster
        position={isMobile ? "top-center" : "top-right"}
        reverseOrder={true}
      />
      {children}
    </div>
  );
};

export default ToastWindow;
